import axiosInstance from '../mainService';
const clientService = {
    getClient(search, page, title,company) {
        const sanitizedSearch = search && search.trim() !== '' ? search : 'all';
        return axiosInstance.get(`/data/m141_clients/is_active/${sanitizedSearch}/${page}/${title}/${company}`).then(response => {
            return {
                data: response.data,
                headers: response.headers, // Total data dari header
            };
        });
    },
    totalAllClient(search, company) {
        const sanitizedSearch = search && search.trim() !== '' ? search : 'all';
        return axiosInstance.get(`/count-data/m141_clients/is_active/${sanitizedSearch}/${company}`);
    },
    addClient(data) {
        return axiosInstance.post('/upload-data-client', data);
    },
    updateClient(data) {
        return axiosInstance.put(`/update-data/m141_clients/${data.id}`, data);
    },
    deleteClient(id, gambar) {
        return axiosInstance.delete(`/delete-client/${id}/${gambar}`);
    },
};

export default clientService;